import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './FieldLabel-hashed.scss';
import defaultTranslator from '@elixir/translator';
import cx from 'classnames';
import { defaultTheme } from '@elixir/theme';

/**
 * Class renders label for `FieldComponent`.
 */
export default class FieldLabel extends PureComponent {
    static propTypes = {
        /**
        * Used to identify the component. Applied to control and referenced by label
        **/
        id: PropTypes.string.isRequired,
        /**
        * Text to display; if not provided, uses the value of the '[id]' prop
        **/
        label: PropTypes.string,
        /**
        * Text for secondary label
        **/
        secondaryLabel: PropTypes.string,
        /**
        * If true, this field is required
        **/
        required: PropTypes.bool,
        /**
        * If true, this field is readonly?
        **/
        readOnly: PropTypes.bool,
        /**
        * If true, the label is not visible
        **/
        hideLabel: PropTypes.bool,
        /**
        * CSS class, provides an additional style to apply to the component
        **/
        className: PropTypes.string,
        /**
        * CSS class, provides an additional style to apply to primary label
        **/
        labelClassName: PropTypes.string,
        /**
        * CSS class, provides an additional style to apply to secondary label
        **/
        secondaryLabelClassName: PropTypes.string,
        /**
        * If true, displays the `Optional` span
        **/
        showOptional: PropTypes.bool,
        /**
        * The icon to us ein the tooltip. Use Font Awesome keyword, like "calendar" without any prefix
        **/
        tooltipIcon: PropTypes.node
    };
    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    static defaultProps = {
        theme: defaultTheme
    };

    render() {
        const { theme } = this.props;
        const themeProps = theme.getProps('FieldLabel', this.props);
        const themeStyles = theme.getStyles('FieldLabel', styles);
        const {
            id,
            label,
            required,
            readOnly,
            hideLabel,
            showOptional,
            className,
            labelClassName,
            secondaryLabelClassName,
            tooltipIcon,
            secondaryLabel
        } = themeProps;

        const translator = this.context.translator || defaultTranslator;
        if (hideLabel) {
            return null;
        }

        const translatedLabel = translateLabel(label, translator);
        const translatedSecondaryLabel = translateLabel(secondaryLabel, translator);
        let optionalIndicator;
        if (showOptional && !required && !readOnly) {
            optionalIndicator = (<span className={themeStyles.optional}>
                {translator({ id: 'portal.common.FieldList.Optional', defaultMessage: '(Optional)' })}</span>);
        }
        const classes = cx(
            themeStyles.fieldLabel,
            className
        );
        return (
            <label className={classes} htmlFor={id}>
                <span className={labelClassName}>{translatedLabel}</span>
                <span className={cx(themeStyles.secondaryLabel, secondaryLabelClassName)}>{translatedSecondaryLabel}</span>
                {optionalIndicator}
                {tooltipIcon}
            </label>
        );
    }
}

function translateLabel(label, translator) {
    return label && translator(label);
}
